import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type Params = {
  territoryId: string
}

export const deleteTerritory = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/delete', async (params: Params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/territory/deleteTerritory', {
      category: 'rpc',
      type: 'rpc/territory/deleteTerritory',
      payload: params,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Delete Territory Failed',
      error,
    })
  }
})
